import { Config, AuthHeader } from "../helpers/Config";
import { UserService } from "./UserService";

export const DepositService = {
  /**
   * [FASTPAY]
   * @param {object} data
   * @param {number} data.login
   * @param {number} data.amount
   * @param {string} data.currency
   */
  FastPay(data) {
    var requestOptions = {
      method: "POST",
      headers: AuthHeader(),
      body: JSON.stringify(data),
    };

    return DepositService.Common.Fetch(
      Config.service.deposit.FastPay,
      requestOptions
    );
  },
  /**
   * [NETELLER]
   * @param {object} data
   * @param {number} data.login
   * @param {number} data.amount
   * @param {string} data.currency
   * @param {string} data.accountID
   * @param {string} data.secureID
   */
  Neteller(data) {
    var requestOptions = {
      method: "POST",
      headers: AuthHeader(),
      body: JSON.stringify(data),
    };

    return DepositService.Common.Fetch(
      Config.service.deposit.Neteller,
      requestOptions
    );
  },
  /**
   * [SKRILL]
   * @param {object} data
   * @param {number} data.login
   * @param {number} data.amount
   * @param {string} data.currency
   */
  Skrill(data) {
    var requestOptions = {
      method: "POST",
      headers: AuthHeader(),
      body: JSON.stringify(data),
    };

    return DepositService.Common.Fetch(
      Config.service.deposit.Skrill,
      requestOptions
    );
  },
  /**
   * [CREDIT_CARD]
   * @param {object} data
   * @param {number} data.login
   * @param {number} data.amount
   * @param {string} data.currency
   * @param {string} data.cardNumber
   * @param {string} data.expMonth
   * @param {string} data.expYear
   * @param {string} data.cvv
   */
  CreditCard(data) {
    var requestOptions = {
      method: "POST",
      redirect: "manual",
      headers: AuthHeader(),
      body: JSON.stringify(data),
    };

    return DepositService.Common.Fetch(
      Config.service.deposit.CreditCard,
      requestOptions
    );
  },
  /**
   * [COMMUNITY_BANK]
   * @param {object} data
   * @param {number} data.login
   * @param {number} data.amount
   * @param {string} data.currency
   * @param {string} data.bankCode
   * @param {number} data.activeAmountId
   */
  CommunityBank(data) {
    var requestOptions = {
      method: "POST",
      redirect: "manual",
      headers: AuthHeader(),
      body: JSON.stringify(data),
    };

    return DepositService.Common.Fetch(
      Config.service.deposit.CommunityBank,
      requestOptions
    );
  },
  /**
   * [QRCODE]
   * @param {object} data
   * @param {number} data.login
   * @param {number} data.amount
   * @param {string} data.currency
   */
  QrCode(data) {
    var requestOptions = {
      method: "POST",
      redirect: "manual",
      headers: AuthHeader(),
      body: JSON.stringify(data),
    };

    return DepositService.Common.Fetch(
      Config.service.deposit.QrCode,
      requestOptions
    );
  },
  /**
   * [ZOTAPAY]
   * @param {object} data
   * @param {number} data.login
   * @param {number} data.amount
   * @param {string} data.currency
   */
  ZotaPay(data) {
    var requestOptions = {
      method: "POST",
      redirect: "manual",
      headers: AuthHeader(),
      body: JSON.stringify(data),
    };

    return DepositService.Common.Fetch(
      Config.service.deposit.ZotaPay,
      requestOptions
    );
  },
  /**
   * [ZOTAPAY_QRCODE]
   * @param {object} data
   * @param {number} data.login
   * @param {number} data.amount
   * @param {string} data.currency
   */
  ZotaPayQrCode(data) {
    var requestOptions = {
      method: "POST",
      redirect: "manual",
      headers: AuthHeader(),
      body: JSON.stringify(data),
    };

    return DepositService.Common.Fetch(
      Config.service.deposit.ZotaPayQrCode,
      requestOptions
    );
  },
  /**
   * [FLASHPAY]
   * @param {object} data
   * @param {number} data.login
   * @param {number} data.amount
   * @param {string} data.currency
   * @param {string} data.userGuid
   * @param {string} data.token
   */
  FlashPay(data) {
    var requestOptions = {
      method: "POST",
      redirect: "manual",
      headers: AuthHeader(),
      body: JSON.stringify(data),
    };

    return DepositService.Common.Fetch(
      Config.service.deposit.flashPay,
      requestOptions
    );
  },
  /**
   * [FLASHPAY_DEPOSIT_TO_KOINTRA]
   * @param {object} data
   * @param {number} data.amount
   * @param {string} data.userGuid
   * @param {string} data.token
   */
  FlashPayDepositToKointra(data) {
    var requestOptions = {
      method: "POST",
      redirect: "manual",
      headers: AuthHeader(),
      body: JSON.stringify(data),
    };

    return DepositService.Common.Fetch(
      Config.service.deposit.flashPayDepositToKointra,
      requestOptions
    );
  },
  /**
   * [FLASHPAY_CANCEL_ON_KOINTRA]
   * @param {object} data
   * @param {string} data.userGuid
   * @param {string} data.token
   */
  FlashPayCancelDeposit(data) {
    var requestOptions = {
      method: "POST",
      headers: AuthHeader(),
      body: JSON.stringify(data),
    };
    return DepositService.Common.Fetch(
      Config.service.deposit.cancelDepositOnKointra,
      requestOptions
    );
  },
  TPay(data) {
    var requestOptions = {
      method: "POST",
      headers: AuthHeader(),
      body: JSON.stringify(data),
    };
    return DepositService.Common.Fetch(
      Config.service.erc20.deposit.Tpay,
      requestOptions
    );
  },

  TPayTRC20(data) {
    var requestOptions = {
      method: "POST",
      headers: AuthHeader(),
      body: JSON.stringify(data),
    };
    return DepositService.Common.Fetch(
      Config.service.trc20.deposit.Tpay,
      requestOptions
    );
  },
  Unipayment(data) {
    var requestOptions = {
      method: "POST",
      headers: AuthHeader(),
      body: JSON.stringify(data),
    };

    return DepositService.Common.Fetch(
      Config.service.deposit.Unipayment,
      requestOptions
    );
  },
  /**
   * [DEPOSIT_DETAIL]
   * @param {object} data
   * @param {string} data.transactionId
   */
  Detail(data) {
    var requestOptions = {
      method: "POST",
      headers: AuthHeader(),
      body: JSON.stringify(data),
    };

    return DepositService.Common.Fetch(
      Config.service.deposit.detail,
      requestOptions
    );
  },

  getRefundInvoices() {

    var requestOptions = {
      method: 'GET',
      headers: AuthHeader()
    }
    return DepositService.Common.Fetch(Config.service.deposit.getRefundInvoices, requestOptions);
  },
  //return TransferOptionService.Common.Fetch(Config.service.trc20.deposit.Tpay, requestOptions);
  /**
   * [COMMON]
   * @function Fetch
   */
  Common: {
    Fetch(url, requestOptions) {
      return fetch(url, requestOptions)
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else if (response.status === 401) {
            UserService.Logout();

            window.location.reload();
          } else {
            throw new Error();
          }
        })
        .then((json) => {
          if (json.redirect) {
            setTimeout(() => {
              window.location.href = json.redirect;
            }, 10);
            return json;
          } else {
            return json;
          }
        })
        .catch((err) => {
          return false;
        });
    },
  },
};
